import { Power0, Power3 } from 'gsap'
import TimelineMax from 'gsap/TimelineMax'
import { bindInViewTimelineStagger } from '../util/animations'

class PressEntryListed {
  constructor ($el, masterTimeline) {
    this.$el = $el
    if (typeof $el.data('animateIn') === 'undefined' || $el.data('animateIn') === true) {
      this.timelineIn = new TimelineMax({ paused: true, onComplete: () => { this.$el.data('animateInDone', true) } })
      this.buildTimelineIn()
      this.$el.data('offset', '90%')
      bindInViewTimelineStagger($el, this.timelineIn, masterTimeline)
    }
    this.timelineHover = new TimelineMax({ paused: true })
    this.lineScaleTo = (38 - $el.find('header').height() + 55) / 55
    this.buildTimelineHover()
  }

  buildTimelineIn () {
    this.timelineIn
      .fromTo(this.$el.find('.press-entry-listed__image .inner'), 0.8, { x: '-100%' }, { x: '0%', ease: Power3.easeOut }, 0)
      .fromTo(this.$el.find('.press-entry-listed__image img'), 0.8, { x: '100%' }, { x: '0%', ease: Power3.easeOut }, 0)
      .fromTo(this.$el.find('.v-line'), 0.6, { scaleY: 0 }, { scaleY: 1, ease: Power3.easeInOut }, 0)
      .fromTo(this.$el.find('header'), 0.3, { opacity: 0 }, { opacity: 1, ease: Power0.easeNone }, 0)
      .fromTo(this.$el.find('header'), 0.8, { y: '-30px' }, { y: '0px', ease: Power3.easeOut }, 0)
  }

  buildTimelineHover () {
    const $el = this.$el
    const $line = $el.find('.v-line')
    this.timelineHover
      .to(
        $el.find('img'),
        0.2,
        {
          opacity: 1,
          ease: Power0.easeNone,
        },
        0
      )
      .to(
        $el.find('header'),
        0.4,
        {
          y: '-70px',
          ease: Power3.easeInOut,
        },
        0
      )
      .to(
        $line,
        0.2,
        {
          scaleY: 0,
          borderLeftColor: 'white',
          ease: Power3.easeInOut,
        },
        0
      )
      .to(
        $line,
        0.01,
        {
          transformOrigin: 'bottom center',
          y: '50px',
        },
        0.2
      )
      .to(
        $line,
        0.2,
        {
          scaleY: this.lineScaleTo,
          borderLeftColor: '#a78a60',
          ease: Power3.easeInOut,
        },
        0.21
      )

    $el.data('timelineHover', this.timelineHover)
  }
}

export default PressEntryListed



// WEBPACK FOOTER //
// ./scripts/components/PressEntryListed.js